import React, { useState } from 'react';
import styles from './VendorTable.module.scss';
import { Grid, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TablePagination, Button } from '@mui/material';
import { MdDelete } from "react-icons/md";
import * as XLSX from "xlsx"; 

export interface IVendorTable {
  data: any;
  handleDelete: any;
}

const UserTable = ({ data, handleDelete }: IVendorTable) => {
  const [page, setPage] = useState(0); 
  const [rowsPerPage, setRowsPerPage] = useState(5);

  const handleChangePage = (event: any, newPage: number) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0); 
  };

  const exportToExcel = () => {
    const ws = XLSX.utils.json_to_sheet(data);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Users");
    XLSX.writeFile(wb, "UserTable.xlsx");
  };

  const paginatedData =data && data?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

  return (
    <Grid>
      {/* Export to Excel Button */}
      <Button onClick={exportToExcel} variant="contained" color="primary" style={{ marginBottom: '16px' }}>
        Export to Excel
      </Button>

      <TableContainer>
        <Table>
          <TableHead sx={{ backgroundColor: "#3FACE2", width: "100%" }}>
            <TableRow>
              <TableCell sx={{ textAlign: "center", fontSize: 16, fontWeight: 600 }}>User Id</TableCell>
              <TableCell sx={{ textAlign: "center", fontSize: 16, fontWeight: 600 }}>Phone</TableCell>
              <TableCell sx={{ textAlign: "center", fontSize: 16, fontWeight: 600 }}>Action</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {paginatedData && paginatedData?.map((item: any) => {
              return (
                <TableRow key={item._id}>
                  <TableCell sx={{ textAlign: "center" }}>{item?.userId}</TableCell>
                  <TableCell sx={{ textAlign: "center" }}>{item?.mobileNumber}</TableCell>
                  <TableCell sx={{ textAlign: "center" }}>
                    <MdDelete onClick={() => handleDelete(item._id)} fontSize={21} cursor={"pointer"} style={{ color: "red" }} />
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>

      <TablePagination
        rowsPerPageOptions={[5, 10, 25]}
        component="div"
        count={data?.length} 
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </Grid>
  );
};

export default UserTable;
